<!-- Only show in test environment -->
<div class="insurance-list-related-vehicle" *ngIf="isTest && purchasedProduct.product.relatedVehicle">
    heeft gerelateerd voertuig: {{ purchasedProduct.product?.relatedVehicle.licensePlate }} ({{
        purchasedProduct.relatedVehicle?.vehicleReplacementTypeDescription
    }})
</div>
